<template>
    <div>
      <audio v-if="isAudio" ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered"></audio>
      <video v-else ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered"></video>
    </div>
  </template>
  
  <script>
  import videojs from 'video.js';
  import 'video.js/dist/video-js.css';
  
  export default {
    name: 'VideoPlayer',
    props: {
      isAudio: {
        type: Boolean,
        default: false
      },
      options: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    data() {
      return {
        player: null
      }
    },
    mounted() {
      this.player = videojs(this.$refs.videoPlayer, this.options, () => {
        this.player.log('onPlayerReady', this);
      });
    },
    beforeUnmount() {
      if (this.player) {
        this.player.dispose();
      }
    }
  }
  </script>

  <style scoped>
  .video-js.vjs-tech {
    display: none;
  }
  </style>